<template>
    <div>
        <div v-if="general && general.datos && general.datos.datos_medicos">
            <form autocomplete="off" @submit.prevent="postDatosMedicos()">
                <vs-row class="p-4">
                    <vs-col w="12" class="lineTitulo mb-2">
                        <h5><strong>DATOS MÉDICOS</strong></h5>
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Enfermedades</label>
                        <vs-input
                            class="pt-0"
                            v-model="info.enfermedades"
                            placeholder="Enfermedades"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Medicamentos</label>
                        <vs-input
                            class="pt-0"
                            v-model="info.medicamentos"
                            placeholder="Medicamentos"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Tipo de sangre</label>
                        <vs-select 
                            filter 
                            class="pt-0"
                            placeholder="Tipo de sangre"
                            :key="sangreId" 
                            v-model="info.tipo_sangre"
                            :disabled="deshabilitadas"
                        >
                            <vs-option
                                v-for="option in tipos_sangre" 
                                :key="option.id"
                                :label="option.text"
                                :value="option.id"
                                :disabled="deshabilitadas"
                            >
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Alergias</label>
                        <vs-input
                            class="pt-0"
                            v-model="info.alergias"
                            placeholder="Alergias"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Peso</label>
                        <vs-input
                            type="number"
                            class="pt-0"
                            min="0"
                            v-model="info.peso_kg"
                            placeholder="Peso"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Estatura (cm)</label>
                        <vs-input
                            type="number"
                            class="pt-0"
                            min="0"
                            v-model="info.estatura_cm"
                            placeholder="Estatura (cm)"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Agudeza visual</label>
                        <vs-input
                            class="pt-0"
                            v-model="info.agudeza_visual"
                            placeholder="Agudeza visual"
                            :disabled="deshabilitadas"
                        />
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>¿Tiene discapacidad?</label>
                        <vs-select
                            filter
                            class="pt-0"
                            placeholder="¿Tiene discapacidad?"
                            :key="tiene_discapacidadId" 
                            v-model="info.discapacidad" 
                            :disabled="deshabilitadas"
                        >
                            <vs-option
                                v-for="option in tiene_discapacidad" 
                                :key="option.id"
                                :label="option.text"
                                :value="option.id"
                            >
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4" v-if="info.discapacidad == 'si'">
                        <label>Discapacidad</label>
                        <vs-select
                            filter
                            class="pt-0"
                            placeholder="Discapacidad"
                            :key="discapacidadId" 
                            v-model="info.tipo_discapacidad" 
                            :disabled="deshabilitadas"
                        >
                            <vs-option
                                v-for="option in discapacidades" 
                                :key="option.id"
                                :label="option.text"
                                :value="option.id"
                            >
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="4">
                        <label>Derechohabiente</label>
                        <vs-select
                            filter
                            class="pt-0"
                            placeholder="Derechohabiente"
                            :key="derechohabienteId" 
                            v-model="info.derechohabiente" 
                            :disabled="deshabilitadas"
                        >
                            <vs-option
                                v-for="option in derechoshabientes" 
                                :key="option.id"
                                :label="option.text"
                                :value="option.id"
                            >
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col w="12" class="mt-2">
                        <vs-button
                            v-if="!deshabilitadas"
                            success
                            type="submit"
                            class="ml-auto"
                        >
                            Guardar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </div>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'personaRol',
        'proceso'
    ],
    data(){
        return{
            info: {},
            tipos_sangre: [
                {id: 'A-', text: 'A-'},
                {id: 'A+', text: 'A+'},
                {id: 'B+', text: 'B+'},
                {id: 'B-', text: 'B-'},
                {id: 'O+', text: 'O+'},
                {id: 'O-', text: 'O-'},
                {id: 'AB+', text: 'AB+'},
                {id: 'AB-', text: 'AB-'},
                {id: 'sindefinir', text: 'Sin definir'}
            ],
            sangreId: (new Date()).getTime(),
            tiene_discapacidad: [
                {id: 'si', text: 'Si'},
                {id: 'no', text: 'No'}
            ],
            tiene_discapacidadId: (new Date()).getTime(),
            discapacidades: [
                {id: 'fisica', text: 'Física'},
                {id: 'sensorial', text: 'Sensorial'},
                {id: 'intelectual', text: 'Intelectual'},
                {id: 'psiquica', text: 'Psíquica'},
                {id: 'visceral', text: 'Visceral'},
                {id: 'multiple', text: 'Múltiple'},
                {id: 'sindefinir', text: 'Sin definir'},
                {id: 'auditiva', text: 'Auditiva'},
                {id: 'no', text: 'Sin discapacidad'},
            ],
            discapacidadId: (new Date()).getTime(),
            derechoshabientes: [
                {id: 'imss', text: 'IMSS'},
                {id: 'issste', text: 'ISSSTE'},
                {id: 'no', text: 'No'},
                {id: 'sindefinir', text: 'Sin definir'}
            ],
            derechohabienteId: (new Date()).getTime(),
            deshabilitadas: true
        }
    },
    computed: {
    },
    methods: {
        deshabilitadasOpciones(){
            if(this.general.personaRol.tipoUserPrincipal != 'Personal central - TI'){
                if((this.general.personaRol.tipoUserPrincipal != 'alumno' || ([5, 25, 28].includes(this.general.datos.institucionId)))){
                    if((this.general.permisos.includes('datos-medicos-visualizacion'))){
                        this.deshabilitadas = true
                    }else{
                        this.deshabilitadas = false
                    }
                }else{
                this.deshabilitadas = true
            }
            }else{
                this.deshabilitadas = false
            }
        },
        getInfo(){
            if(this.general.datos.datos_medicos){
            const tipo_sangre = this.general.datos.datos_medicos.tipo_sangre == null ? '' : this.general.datos.datos_medicos.tipo_sangre
            const discapacidad = this.general.datos.datos_medicos.discapacidad == null ? '' : this.general.datos.datos_medicos.discapacidad
            const tipo_discapacidad = this.general.datos.datos_medicos.tipo_discapacidad == null ? '' : this.general.datos.datos_medicos.tipo_discapacidad
            const derechohabiente = this.general.datos.datos_medicos.derechohabiente == null ? '' : this.general.datos.datos_medicos.derechohabiente
            let {enfermedades = '', medicamentos = '', alergias = '', agudeza_visual = '', peso_kg = '', estatura_cm = ''} = this.general.datos.datos_medicos
            Object.assign(this.info = {enfermedades, medicamentos, tipo_sangre, alergias, agudeza_visual, discapacidad, tipo_discapacidad, derechohabiente, peso_kg, estatura_cm})
            }
        },
        async postDatosMedicos(){
                const loading = this.$vs.loading()
                try{
                    const params = {
                        persona_id: this.general.datos.persona_id,
                        enfermedades: this.info.enfermedades,
                        medicamentos: this.info.medicamentos,
                        tipo_sangre: this.info.tipo_sangre,
                        alergias: this.info.alergias,
                        peso_kg: this.info.peso_kg,
                        estatura_cm: this.info.estatura_cm,
                        agudeza_visual: this.info.agudeza_visual,
                        discapacidad: this.info.discapacidad,
                        tipo_discapacidad: this.info.tipo_discapacidad,
                        derechohabiente: this.info.derechohabiente
                    }
                    const {data: response} = await alumnos.postDatosMedicos(this.general.datos.persona_id, params)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        icon: '<i class="fas fa-check"></i>',
                        title: 'Operación éxitosa',
                        text: response.message
                    })
                    loading.close()
                    this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
                }catch{
            }
        }
    },
    watch:{
        general(){
            this.getInfo()
            this.deshabilitadasOpciones()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
</style>
